export default __webpack_public_path__ + "static/media/dunkyClick.c0da2d5e.png";